export const SCORE_COMPONENT_META = [
  {
    key: "relevance",
    label: "Relevance",
    weight: 0.4,
    weightLabel: "40%",
    description: "How closely this article matches campaign triggers and pain points.",
  },
  {
    key: "freshness",
    label: "Freshness",
    weight: 0.2,
    weightLabel: "20%",
    description: "How recent the news is relative to today.",
  },
  {
    key: "persona",
    label: "Persona",
    weight: 0.2,
    weightLabel: "20%",
    description: "How relevant the story is to the prospect's role and ICP fit.",
  },
  {
    key: "credibility",
    label: "Credibility",
    weight: 0.2,
    weightLabel: "20%",
    description: "Trustworthiness of the source publishing this article.",
  },
];

const SCORE_COMPONENT_ALIASES = {
  r: "relevance",
  relevance: "relevance",
  f: "freshness",
  freshness: "freshness",
  p: "persona",
  persona: "persona",
  "persona fit": "persona",
  c: "credibility",
  credibility: "credibility",
};

export function parseScoreComponents(scoreComponents) {
  const scores = {
    relevance: 0,
    freshness: 0,
    persona: 0,
    credibility: 0,
  };

  if (typeof scoreComponents !== "string" || !scoreComponents.trim()) {
    return scores;
  }

  const matches = [
    ...scoreComponents.matchAll(
      /([A-Za-z][A-Za-z\s]*)\s*[:=]\s*(-?\d+(?:\.\d+)?)/g,
    ),
  ];

  for (const [, rawKey, rawValue] of matches) {
    const canonical = SCORE_COMPONENT_ALIASES[rawKey.trim().toLowerCase()];
    if (canonical) {
      scores[canonical] = Math.max(0, Math.min(10, Number(rawValue) || 0));
    }
  }

  return scores;
}

export function computeNewsScoreFromComponents(scoreComponents) {
  const scores = parseScoreComponents(scoreComponents);
  return SCORE_COMPONENT_META.reduce(
    (total, { key, weight }) => total + scores[key] * weight * 10,
    0,
  );
}
